// 设置商品范围
<template>
  <div class="set-goods-range">
    <el-radio-group
      v-model="value"
      @change="radioChange"
    >
      <el-radio :label="1">选全部小店商品</el-radio>
      <br />
      <el-radio :label="4">选展架分类下商品</el-radio>
      <br />
      <el-cascader
        ref="displayCategory"
        class="mgb16 category-select"
        v-model="displayValue"
        :options="displayOptions"
        :props="{expandTrigger:'hover'}"
        :show-all-levels="false"
        :showTags="false"
        clearable
        :disabled="value !== 4"
        @visible-change="displayChange"
      >
     </el-cascader>
      <br />
      <el-radio :label="2">选分类下所有商品</el-radio>
      <br />
      <el-select
        v-model="category"
        class="mgb16 category-select"
        :disabled="value !== 2"
        @change="closePopover"
      >
        <el-option :value="0" label="全部" />
      </el-select>
      <br />
      <el-radio :label="3">
        <span @click="$emit('openChooseGoods3')">
          选指定商品
        </span>
      </el-radio>
    </el-radio-group>
    <ChooseGoods
      ref="chooseGoods"
      @handleChoose="handleChoose"
      @updateGoodsRange="updateGoodsRange"
      @closePopover="closePopover"
    />
  </div>
</template>

<script>
import ChooseGoods from "./ChooseGoods/index.vue";
import { queryBaseItemDisplay } from '@servers/base/display/index.js';

export default {
  components: {
    ChooseGoods,
  },
  data() {
    return {
      value: 1,
      category: 0,
      displayOptions:[],
      displayValue:[0]
    };
  },
  methods: {
    radioChange(v) {
      if (v === 3) {
        this.$refs.chooseGoods.method_open('add', {
          goodsRange: v,
        });
      } else {
        this.$emit('updateGoodsRange', v);
      }
      if (v === 1) {
        this.$emit('close');
      }
    },
    handleChoose(arr, changeRange) {
      this.$emit('handleChoose', arr, changeRange);
    },
    updateGoodsRange(v) {
      this.$emit('updateGoodsRange', v);
    },
    // 获取展架分类数据
    async getBaseItemDisplay(){
        let list = await queryBaseItemDisplay();
        if(list){
          let _list = [];
          _list = list.map(item => ({
            ...item,
            value:item.id,
            label:item.name,
            children:item.list ? item.list.map(c => ({...c,value:c.id,label:c.name})) : null
          }));
          _list.unshift({value:0,label:'全部',children:null});
          this.displayOptions = _list
        }
    },
    displayChange(val){
      if(!val){
        let selectNodes = this.$refs.displayCategory.getCheckedNodes();
        let selectCodes = [];
        selectNodes.forEach(item => {
            if(item.parent){
              // 选了二级分类需要在数组第一项补充一级分类的值
              selectCodes.push(item.parent.data.code)
              selectCodes.push(item.parent.data.code +','+ item.data.code)
            }else{
              selectCodes.push(item.data.code)
            }
        })
        selectCodes = selectCodes.filter(item => item);
        this.$emit('searchGoods', {displayCode:selectCodes});
        this.$emit('close');
      }
    },
    openDialog(mode, params) {
      this.$refs.chooseGoods.method_open(mode, params);
    },

    closePopover(show) {
      this.$emit('close', show);
    }
  },
  created(){
      this.getBaseItemDisplay();
  },

}

</script>

<style lang='scss' scoped>
.set-goods-range {
  padding: 12px;
}
.el-radio:not(:last-child) {
  margin-bottom: 16px;
}

.category-select {
  width: 200px;
}
::v-deep .el-select-dropdown.el-popper {
  width: 200px;
}
</style>
